<template>
<div class="chapter">
<div class="inner_page">
<section class="titlepage" epub:type="titlepage">
<div class="title_page_image"><img alt="Throne of Isis by Judith Tarr" src="images/scale~1920x1200~thronetitle-1562591475-60.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0.vue?207992c7